import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmComponent } from '../confirm/confirm.component';
import { InformComponent } from '../inform/inform.component';
import { YesNoCancelComponentComponent } from '../yes-no-cancel-component/yes-no-cancel-component.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {

  constructor(private modalService: NgbModal) { }

  confirm(title?: string,
    prompt?: string,
    okBtnText?: string,
    cancelBtnText?: string,
    okBtnIcon?: string,
    cancelBtnIcon?: string,
    okBtnClass?: string,
    cancelBtnClass?: string): Promise<any> {
    const modal = this.modalService.open(ConfirmComponent);
    if (title) {
      modal.componentInstance.title = title;
    }
    if (prompt) {
      modal.componentInstance.prompt = prompt;
    }
    if (cancelBtnClass) {
      modal.componentInstance.cancelBtnClass = cancelBtnClass;
    }
    if (okBtnClass) {
      modal.componentInstance.okBtnClass = okBtnClass;
    }
    if (cancelBtnText) {
      modal.componentInstance.cancelBtnText = cancelBtnText;
    }
    if (okBtnText) {
      modal.componentInstance.okBtnText = okBtnText;
    }
    modal.componentInstance.cancelBtnIcon = cancelBtnIcon || 'fa-times';
    modal.componentInstance.okBtnIcon = okBtnIcon || 'fa-check';

    return modal.result;
  }

  delete(title?: string,
    prompt?: string,
    okBtnText?: string,
    cancelBtnText?: string,
    okBtnIcon?: string,
    cancelBtnIcon?: string,
    okBtnClass?: string,
    cancelBtnClass?: string): Promise<any> {
    return this.confirm(title, prompt, okBtnText || 'Delete', cancelBtnText, okBtnIcon || 'fa-trash-alt', cancelBtnIcon, okBtnClass || 'btn-danger', cancelBtnClass);
  }

  yesNoCancel(title?: string,
    prompt?: string): Promise<any> {
    const modal = this.modalService.open(YesNoCancelComponentComponent);
    if (title) {
      modal.componentInstance.title = title;
    }
    if (prompt) {
      modal.componentInstance.prompt = prompt;
    }
    return modal.result;
  }

  inform(title?: string,
    prompt?: string): void {
    const modal = this.modalService.open(InformComponent);
    if (title) {
      modal.componentInstance.title = title;
    }
    if (prompt) {
      modal.componentInstance.prompt = prompt;
    }
    modal.result.then(() => { }, () => { });
  }
}
